export const subjectLibTableOption = {
  border: true,
  stripe: true,
  menuAlign: 'center',
  align: 'center',
  refreshBtn: false,
  editBtn: false,
  delBtn: false,
  addBtn: false,
  viewBtn: false,
  column: [
	  {
      label: '题库名称',
      prop: 'name',
      width: 250,
      overHidden: true,
    },
    {
      label: '创建人',
      prop: 'creator',
      width: 150,
      overHidden: true,
    },
    {
      label: '题目数',
      prop: 'subjectCount',
      width: 100,
    },
    {
      label: '单选题数',
      prop: 'singleSubjectCount',
      width: 100,
    },
    {
      label: '多选题数',
      prop: 'multipleSubjectCount',
      width: 100,
    },
    {
      label: '判断题数',
      prop: 'judgementSubjectCount',
      width: 100,
    },
    {
      label: '填空题数',
      prop: 'fillSubjectCount',
      width: 100,
    },
    {
      label: '简答题数',
      prop: 'openSubjectCount',
      width: 100,
    },
    {
      label: '创建时间',
      prop: 'insertedTime',
      width: 200,
    },
  ]
}

export const subjectTableOption = {
  selection: true,
  reserveSelection:true,
  tip:false,
  border: true,
  stripe: true,
  menuAlign: 'center',
  align: 'center',
  refreshBtn: true,
  editBtn: false,
  delBtn: false,
  addBtn: false,
  viewBtn: false,
  columnBtn: false,
  column: [
	  {
      label: '题目',
      prop: 'content',
      overHidden: true,
    },
    {
      label: '类型',
      prop: 'type',
    },
    {
      label: '创建时间',
      prop: 'insertedTime',
    },
  ]
}

export const subjectLibDialogOption = {
  height:300,
  border: true,
  stripe: false,
  menu: false,
  align: 'center',
  refreshBtn: false,
  editBtn: false,
  delBtn: false,
  addBtn: false,
  viewBtn: false,
  columnBtn: false,
  highlightCurrentRow:true, // 行单选
  column: [
	  {
      label: '题库名称',
      prop: 'name',
      overHidden: true,
    },
    {
      label: '创建人',
      prop: 'creator',
      overHidden: true,
    },
    {
      label: '题目数',
      prop: 'subjectCount',
    }
  ]
}

export const subjectDialogOption = {
  height:300,
  selection: true,
  reserveSelection:true,
  tip:false,
  border: true,
  stripe: false,
  menu: false,
  align: 'center',
  refreshBtn: false,
  editBtn: false,
  delBtn: false,
  addBtn: false,
  viewBtn: false,
  columnBtn: false,
  column: [
	  {
      label: '题目',
      prop: 'content',
      overHidden: true,
    },
    {
      label: '类型',
      prop: 'type',
    },
    {
      label: '创建时间',
      prop: 'insertedTime',
    },
  ]
}

export const subjectTypeList = [
  {
    label: '单选题',
    name: 'single',
    value: 1,
  },
  {
    label: '多选题',
    name: 'mutiple',
    value: 2,
  },
  {
    label: '判断题',
    name: 'judgement',
    value: 3,
  },
  // {
  //   label: '填空题',
  //   name: 'fill',
  //   value: '4',
  // },
  // {
  //   label: '简答题',
  //   name: 'question',
  //   value: '5',
  // }
]

export const subjectTypeMap = {
  single: {
    name: '单选题',
    value: 1
  },
  mutiple:{
    name: '多选题',
    value: 2,
  },
  judgement: {
    name: '判断题',
    value: 3
  },
  fill: {
    name: '填空题',
    value: 4
  },
  question: {
    name: '简答题',
    value: 5
  },
}
